<template>
    <div class="page">
        <div style="padding: 30px 10px 0;"> <!--绑定-->
            <mt-field placeholder="请输入账号" v-model.trim="account.userNo">
                <img src="../assets/user.png" alt="" class="account-icon input-icon2">
            </mt-field>
            <mt-field placeholder="请输入密码" type="password" v-model.trim="account.password">
                <img src="../assets/pass.png" alt="" class="account-icon input-icon2">
            </mt-field>
            <mt-button type="primary" style="width: 100%;" class="mt-gap2" @click="login()" :disabled="btnLoading">登录</mt-button>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                btnLoading: false,
                companyNo: '',
                account: {
                    userNo: '',
                    password: '',
                    loginType: 1,
                }
            }
        },
        created() {
            document.title="登录";
            if (!this.$route.query.companyNo) {
                this.$toast("公司代号失踪了~");
                return;
            }
            this.$util.cookieClear();
            this.companyNo = this.$route.query.companyNo.toUpperCase();
            this.account.companyNo = this.companyNo;
            this.$util.set('companyNo', this.companyNo);
        },
        methods: {
            login() {
                if (!this.account.userNo) {
                    this.$toast("请输入账号");
                    return false;
                }
                if (!this.account.password) {
                    this.$toast('请输入密码');
                    return false;
                }
                this.btnLoading = true;
                this.http.sendNormal({command: 'rWeixinClient/WebLogin', params: this.account}).then(res => {
                    if(res.data.result_code === 0) {
                        let token = res.data.body[0].token;
                        let accountType = res.data.body[0].accountType;
                        let userNo = res.data.body[0].userNo;
                        let clientNo = res.data.body[0].clientNo;
                        let role = res.data.body[0].role;
                        let companyName = res.data.body[1].companyName;
                        this.$util.set(this.companyNo+"_token", token);
                        let userInfo = {
                            accountType,
                            userNo,
                            companyName,
                            role,
                            clientNo
                        };
                        this.$util.set(this.companyNo+"_userInfo", userInfo);
                        this.$router.replace({name: 'Main'});
                    }
                    this.btnLoading = false;
                }).catch(err => {
                    this.btnLoading = false;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/mbLogin.vue